<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <!-- <el-dialog
      title="提现审核"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>提现审核</span>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入提现审核备注"
        v-model="refundPostData.refuse_reason"
      ></el-input>
      <el-radio v-model="refundPostData.status" :label="1">同意</el-radio>
      <el-radio v-model="refundPostData.status" :label="2">驳回</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundSubmit">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      title="发起分账"
      :visible.sync="dialogVisibleLog"
      width="50%"
      v-if="info != ''"
    >
      <span class="info-class">
        <div class="item">
          <div class="left">订单</div>
          <div class="right">{{ info.trade_no }}</div>
        </div>
        <div class="item">
          <div class="left">状态</div>
          <div class="right">{{ statusDict[info.status].text }}</div>
        </div>
        <div class="item">
          <div class="left">佣金金额</div>
          <div class="right">{{ info.rebate_money }}</div>
        </div>
        <div class="item">
          <div class="left">分账金额</div>
          <div class="right">{{ info.share_amount }}</div>
        </div>
        <div class="item">
          <div class="left">剩余金额</div>
          <div class="right">{{ info.unfreeze_amount }}</div>
        </div>
        <div class="item">
          <div class="left">创建时间</div>
          <div class="right">{{ info.create_time }}</div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleLog = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="refundSubmit" size="small"
            >确 定</el-button
          >
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as routing from "@/api/routing/link.js";
import * as order from "@/api/product/order.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      statusDict: {
        "-1": { text: "已作废", type: "danger", value: "-1" },
        "0": { text: "未审核", type: "warning", value: "0" },
        "1": { text: "财审通过", type: "success", value: "1" },
        "2": { text: "财审失败", type: "danger", value: "2" },
        "3": { text: "已确认", type: "success", value: "3" },
        "4": { text: "分账中", type: "info", value: "4" },
        "5": { text: "分账完成", type: "success", value: "5" }
      },
      dialogVisibleLog: false,
      dialogVisible: false,
      refundPostData: {
        rebate_id: "",
        status: 1,
        refuse_reason: ""
      },
      info: "",
      searchDesc: {
        trade_no: {
          label: "订单号",
          type: "input"
        },
        date_type: {
          label: "日期类型",
          type: "select",
          default: 1,
          options: [
            {
              text: "创建日期",
              value: 1
            },
            {
              text: "补贴日期",
              value: 2
            }
          ]
        },
        date: {
          field: "date",
          label: "时间范围",
          type: "daterange",
          attrs: {
            valueFormat: "yyyy-MM-dd",
            pickerOptions: {
              shortcuts: [
                {
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      searchData: {},
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "佣金列表",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "trade_no",
            // 列名
            label: "订单号",
            hide: true
          },
          {
            prop: "member",
            // 列名
            label: "受益人",
            hide: true
          },
          {
            prop: "rebate_money",
            // 列名
            label: "补贴金额",
            hide: true
          },
          {
            prop: "share_amount",
            // 列名
            label: "分账金额",
            hide: true
          },
          {
            prop: "unfreeze_amount",
            // 列名
            label: "剩余金额",
            hide: true
          },
          {
            prop: "create_time",
            label: "创建时间",
            hide: true
          },
          {
            prop: "update_time",
            label: "更新时间",
            hide: true
          },
          {
            prop: "status",
            show: "tag",
            label: "补贴状态",
            hide: true,
            width: 100,
            tagtype: [
              {
                text: " 已作废",
                type: "danger",
                value: -1
              },
              {
                text: "未审核",
                type: "warning",
                value: 0
              },
              {
                text: "财审通过",
                type: "success",
                value: 1
              },
              {
                text: "财审失败",
                type: "danger",
                value: 2
              },
              {
                text: "已确认",
                type: "info",
                value: 3
              },
              {
                text: "分账中",
                type: "info",
                value: 4
              },
              {
                text: "分账完成",
                type: "success",
                value: 5
              }
            ]
          }
        ],
        btnNavLeft: [
          {
            text: "导出",
            size: "mini",
            type: "",
            click: () => {
              console.log("导出");
              let that = this;
              let param;
              if (this.searchData) {
                param = {
                  type: 1,
                  ...this.searchData
                };
              }
              order.exportRebateFile.r(param).then(res => {});
            }
          }
        ],
        btnList: [
          {
            name: "发起分账",
            size: "mini",
            type: "text",
            Vif: data => {
              return data.status == 3;
            },
            click: (id, row, index) => {
              this.dialogVisibleLog = true;
              this.formData = {
                member_id: row.member_id,
                rebate_money: row.rebate_money,
                rebate_id: this.tableData[index].rebate_id,
                order_id: this.tableData[index].order_id,
                rebate_reason: this.tableData[index].rebate_reason
              };
              this.info = this.tableData[index];
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    //   提交
    refundSubmit() {
      routing.routingPush
        .r(this.formData)
        .then(res => {
          this.$message({
            type: "success",
            message: "分账成功"
          });
          this.dialogVisibleLog = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "分账失败"
          });
          this.dialogVisibleLog = false;
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 搜索提交
    searchSubmit(e) {
      this.searchData = e;
      if (e.date) {
        let date = {
          start_time: e.date[0],
          end_time: e.date[1]
        };
        delete e.date;
        this.searchData = {
          ...e,
          ...date
        };
      }
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      order.getMemberRebate.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: end;
}
.info-class {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 50%;
    display: flex;
    line-height: 40px;
    font-size: 14px;
    // &:nth-child(1) {
    //   border-top: 1px solid #dcdfe6;
    // }
    // border-bottom: 1px solid #dcdfe6;
    .left {
      font-weight: 500;
      font-size: 13px;
      padding-left: 10px;
      margin-right: 10px;
      width: 90px;
    }
    .right {
      width: calc(100% - 100px);
      color: #303133;
    }
  }

  .credentials {
    margin-top: 10px;
    line-height: 35px;
    width: 100%;
    .credentials-body {
      width: 100%;
      .credentials-item {
        width: 100%;
        display: flex;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }

        .item-left {
          width: 50%;
          padding-left: 10px;
        }
        .item-right {
          padding-left: 10px;
          width: 50%;
        }
      }
    }
  }
}
</style>
